module.exports = __webpack_public_path__ + "img/wangcheng_big.02824126.png";